export enum WinReasonEnum {
  ACE = 'ACE',
  DOUBLE_FAULT = 'DOUBLE_FAULT',
  ERROR = 'ERROR',
  FORCED = 'FORCED',
  NET_CORD = 'NET_CORD',
  PENALTY = 'PENALTY',
  UNFORCED = 'UNFORCED',
  WINNER = 'WINNER'
}
